import { RequestHandler, rest } from 'msw'

import { PROJECT_ID } from '__test-utils__/ids'

import config from 'config'

import { GetProjectResponse } from '../types'
import { useGetProjectMockResponse } from './useGetProjectMockResponse'

export const useGetProjectHandlers: RequestHandler[] = [
  rest.get(
    `${config.getProjectExplorerApiBaseUrl()}/v1/projects/${PROJECT_ID}`,
    (_req, res, ctx) => {
      return res(ctx.json<GetProjectResponse>(useGetProjectMockResponse))
    }
  )
]
